export default "__VITE_ASSET__D6v8s8fV__"